import React from 'react';
import { UsersIcon, ClockIcon, DollarSignIcon } from 'lucide-react';
export function KeyHighlights() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1276">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1277">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-1278">
          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1279">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-1280">
              <UsersIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-1281" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1282">
              Class Size: 6–25
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1283">
              Minimum 6 students, maximum 25 students per class.
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1284">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-1285">
              <ClockIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-1286" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1287">
              4 Hours
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1288">
              Comprehensive classroom instruction covering strategies and
              response plans.
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1289">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-1290">
              <DollarSignIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-1291" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1292">
              FREE
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1293">
              No cost for FLSC members and non-members alike.
            </p>
          </div>
        </div>
      </div>
    </div>;
}